import { Spinner } from '@fluentui/react-components';
import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { requireSettingsSection } from '../../lib/router/route-guards';

const CategoryPage = lazy(() =>
  import('../../pages/settings/category/CategoryPage').then((m) => ({
    default: m.CategoryPage,
  })),
);

export const Route = createFileRoute('/settings/category')({
  beforeLoad: ({ context }) => requireSettingsSection(context.queryClient, 'category'),
  component: () => (
    <Suspense fallback={<Spinner style={{ position: 'absolute', top: '25%', left: '50%' }} />}>
      <CategoryPage />
    </Suspense>
  ),
});
